export default __webpack_public_path__ + "static/media/logo-header.5b78a6a2.svg";